var _path, _path2, _path3, _path4, _g, _path5, _g2, _path6, _g3, _path7, _g4, _path8, _g5, _path9, _g6, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 56,
    viewBox: "0 0 77 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.4461 12.6972C53.7725 15.5046 54.5203 18.6467 54.5203 21.9615C54.5203 33.7633 45.0523 43.4236 33.4854 43.4236L20.9236 43.366L19.9712 43.402C23.3153 50.7515 30.6245 55.884 39.0554 55.884H52.0722C56.6651 55.884 60.9229 54.3543 64.394 51.7809C66.0202 53.5193 68.9799 55.884 73.1036 55.884C73.1036 55.884 70.2145 50.9603 69.5407 46.3389C71.7878 42.9233 73.1036 38.8202 73.1036 34.422C73.1036 22.7857 64.0589 12.798 52.7142 12.5244L52.4461 12.6972Z",
    fill: "#FAF2E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.3107 13.9733C62.3813 18.3535 62.5613 24.8645 61.8346 29.6154C61.0338 34.8343 57.6297 39.7832 53.4672 42.8173C49.3117 45.8406 44.1649 46.6828 39.1699 46.7728C36.6829 46.816 34.196 46.6756 31.7126 46.5389C31.0635 46.5029 26.2907 46.9132 26.1178 46.5101L24.5728 42.9613C24.5728 42.9613 43.7593 42.8317 45.8194 41.518C47.8795 40.2043 51.9997 37.4437 52.7687 35.8672C53.5448 34.2908 55.3474 33.373 55.9894 31.0047C56.6349 28.6436 57.5345 29.0359 57.792 26.2754C58.0495 23.5184 58.0495 25.0948 57.9225 21.546C57.792 18.0008 57.792 17.4753 57.5345 16.1616C57.2805 14.8479 56.6349 13.5342 56.6349 13.5342L60.3107 13.9733Z",
    fill: "#00505B",
    fillOpacity: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.26562 22.2161C4.26562 10.6735 13.5255 1.22559 24.8385 1.22559H37.566C48.8789 1.22559 58.1353 10.6735 58.1353 22.2161C58.1353 33.7624 48.8789 43.2067 37.566 43.2067L31.2058 43.7466L24.8385 43.2067C20.3479 43.2067 16.1818 41.713 12.7883 39.1936C11.1973 40.896 8.30118 43.2067 4.26562 43.2067C4.26562 43.2067 7.09474 38.3946 7.7544 33.8704C5.55319 30.5339 4.26562 26.5208 4.26562 22.2161Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_163_48356",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 77,
    height: 56
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 56H77V0H0V56Z",
    fill: "#73DAD2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_163_48356)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.90186 41.9121H10.1491V39.2847H5.90186V41.9121Z",
    fill: "#E6F972"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_163_48356",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 77,
    height: 56
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 56H77V0H0V56Z",
    fill: "#73DAD2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_163_48356)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000488281 22.194C0.000488281 10.3742 9.47909 0.703125 21.0637 0.703125H34.0981C45.6826 0.703125 55.1648 10.3742 55.1648 22.194C55.1648 34.0137 45.6826 43.6884 34.0981 43.6884H21.0637C16.4637 43.6884 12.1989 42.1587 8.72419 39.5781C7.09798 41.3201 4.13128 43.6884 0.000488281 43.6884C0.000488281 43.6884 2.8931 38.7611 3.57393 34.1289C1.3198 30.7097 0.000488281 26.603 0.000488281 22.194Z",
    fill: "#E6F972"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_163_48356",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 77,
    height: 56
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 56H77V0H0V56Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_163_48356)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7348 21.9184C21.7348 23.8439 20.2038 25.4024 18.3166 25.4024C16.4328 25.4024 14.9019 23.8439 14.9019 21.9184C14.9019 19.9928 16.4328 18.4343 18.3166 18.4343C20.2038 18.4343 21.7348 19.9928 21.7348 21.9184Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_163_48356",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 77,
    height: 56
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 56H77V0H0V56Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_163_48356)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.492 21.9184C33.492 23.8439 31.9645 25.4024 30.0773 25.4024C28.1936 25.4024 26.6626 23.8439 26.6626 21.9184C26.6626 19.9928 28.1936 18.4343 30.0773 18.4343C31.9645 18.4343 33.492 19.9928 33.492 21.9184Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_163_48356",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 77,
    height: 56
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 56H77V0H0V56Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_163_48356)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7908 21.9184C44.7908 23.8439 43.2598 25.4024 41.3761 25.4024C39.4889 25.4024 37.9614 23.8439 37.9614 21.9184C37.9614 19.9928 39.4889 18.4343 41.3761 18.4343C43.2598 18.4343 44.7908 19.9928 44.7908 21.9184Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_163_48356",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 77,
    height: 56
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 56H77V0H0V56Z",
    fill: "#00505B",
    fillOpacity: 0.25
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_163_48356)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.82875 40.9617C10.7177 39.1801 12.0688 36.1172 12.4991 33.1658C10.2979 29.8294 9.01035 25.8163 9.01035 21.5116C9.01035 9.96897 18.2667 0.524658 29.5832 0.524658H24.9444C13.6315 0.524658 4.37158 9.96897 4.37158 21.5116C4.37158 25.8163 5.65915 29.8294 7.86036 33.1658C7.2007 37.69 4.37158 42.5022 4.37158 42.5022C6.52693 42.5022 8.34716 41.8363 9.82875 40.9617Z",
    fill: "#00505B",
    fillOpacity: 0.25
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M55.898 12.8486C57.1926 15.5948 57.9228 18.6685 57.9228 21.9078C57.9228 33.4505 48.6664 42.8984 37.3535 42.8984H24.626",
    stroke: "#0C2A4A",
    strokeWidth: 1.11273,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.1021 34.0938C76.1021 22.7131 67.1067 13.384 56.016 13.1176C52.7389 5.93361 45.5956 0.919922 37.3551 0.919922H24.6241C13.3076 0.919922 4.05127 10.3642 4.05127 21.9069C4.05127 26.2115 5.33884 30.221 7.54004 33.5611C6.88039 38.0853 4.05127 42.8974 4.05127 42.8974C8.08682 42.8974 10.983 40.5867 12.5704 38.8843C15.8404 41.3102 19.8301 42.7714 24.1373 42.8758C27.4074 50.0634 34.5578 55.0807 42.8017 55.0807H55.5292C60.0198 55.0807 64.1859 53.5906 67.5794 51.0712C69.1704 52.77 72.0665 55.0807 76.1021 55.0807C76.1021 55.0807 73.2729 50.2722 72.6133 45.748C74.8145 42.4079 76.1021 38.3948 76.1021 34.0938Z",
    stroke: "#01313D",
    strokeWidth: 1.11273,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2454 22.3402C21.2454 24.2658 19.7144 25.8243 17.8307 25.8243C15.9435 25.8243 14.416 24.2658 14.416 22.3402C14.416 20.4147 15.9435 18.8562 17.8307 18.8562C19.7144 18.8562 21.2454 20.4147 21.2454 22.3402Z",
    stroke: "#0C2A4A",
    strokeWidth: 1.09091,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3056 22.3402C44.3056 24.2658 42.7746 25.8243 40.8874 25.8243C39.0036 25.8243 37.4727 24.2658 37.4727 22.3402C37.4727 20.4147 39.0036 18.8562 40.8874 18.8562C42.7746 18.8562 44.3056 20.4147 44.3056 22.3402Z",
    stroke: "#0C2A4A",
    strokeWidth: 1.09091,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7134 13.9824C51.0767 14.7023 51.2284 15.1954 51.5141 16.106",
    stroke: "#01313D",
    strokeWidth: 1.13673,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1753 6.50464C43.1753 6.50464 45.8951 7.37565 48.3961 10.3882",
    stroke: "#01313D",
    strokeWidth: 1.13673,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0063 22.3402C33.0063 24.2658 31.4753 25.8243 29.5916 25.8243C27.7043 25.8243 26.1733 24.2658 26.1733 22.3402C26.1733 20.4147 27.7043 18.8562 29.5916 18.8562C31.4753 18.8562 33.0063 20.4147 33.0063 22.3402Z",
    stroke: "#0C2A4A",
    strokeWidth: 1.09091,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.2f001872789f38ae04d2fbe9953f114b.svg";
export { ForwardRef as ReactComponent };